export const APP_TIME_ZONE = 'America/New_York';

const safeDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateInAppTimeZone = (value, options = {}) => {
  const date = safeDate(value);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    timeZone: APP_TIME_ZONE,
    ...options,
  });
};

export const formatTimeInAppTimeZone = (value, options = {}) => {
  const date = safeDate(value);
  if (!date) return '';
  return date.toLocaleTimeString('en-US', {
    timeZone: APP_TIME_ZONE,
    ...options,
  });
};

export const formatDateTimeInAppTimeZone = (value, options = {}) => {
  const date = safeDate(value);
  if (!date) return '';
  return date.toLocaleString('en-US', {
    timeZone: APP_TIME_ZONE,
    ...options,
  });
};